export const Star = ({ fill = '#dcdce6' }) => (
  <svg
    role='img'
    aria-labelledby='starRating'
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g className='tp-star'>
      <path className='tp-star__canvas' fill={fill} d='M0 46.330002h46.375586V0H0z' />
      <path
        className='tp-star__shape'
        d='M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z'
        fill='#FFF'
      />
    </g>
  </svg>
)

export const HalfStar = ({ fill = '#dcdce6' }) => (
  <svg
    role='img'
    aria-labelledby='starRating'
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g className='tp-star'>
      <path className='tp-star__canvas' fill='#dcdce6' d='M0 46.330002h46.375587V0h-46.375587z' />
      <path
        className='tp-star__canvas--half'
        fill={fill}
        d='M0 46.330002h23.187793V0h-23.187793z'
      />
      <path
        className='tp-star__shape'
        d='M39.533936 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z'
        fill='#FFF'
      />
    </g>
  </svg>
)

const getFillColor = rating => {
  if (rating >= 4.5) return '#007f4e'
  if (rating >= 4) return '#72b043'
  if (rating >= 3) return '#f8cc1b'
  if (rating >= 2) return '#f37324'
  if (rating >= 1) return '#e12729'
  return '#dcdce6'
}

const TrustpilotStars = ({ rating }) => {
  const stars = [...Array.from({ length: 5 })].map((_, index) =>
    index + 1 - rating <= 0.3
      ? 'full'
      : index + 1 - rating < 0.71 && index + 1 - rating > 0.29
      ? 'half'
      : 'none',
  )

  const fillColor = getFillColor(rating)

  return (
    <div sx={{ display: 'flex', svg: { width: 22.5, mr: 1 } }}>
      <For each='star' of={stars} index='i'>
        <Choose>
          <When condition={star === 'full'}>
            <Star key={i} fill={fillColor} />
          </When>

          <When condition={star === 'half'}>
            <HalfStar key={i} fill={fillColor} />
          </When>

          <Otherwise>
            <Star key={i} />
          </Otherwise>
        </Choose>
      </For>
    </div>
  )
}

export default TrustpilotStars
